<template>
  <section class="body">
    <!-- start: header -->
    <header class="header">
      <div class="logo-container">
        <router-link to="/" class="logo align-self-center">
          <img src="@/assets/img/logo.png" height="45" alt="Porto Admin" class="system_logo">
          <span class="h4 font-weight-bold text-blue " style='margin-left:10px'>智慧景區管理平台</span>
        </router-link>
        
        <div class="d-md-none toggle-sidebar-left mobile-nav" data-toggle-class="sidebar-left-opened" data-target="html" data-fire-event="sidebar-left-opened">
          <i class="fa fa-th" aria-label="Toggle sidebar"></i>
        </div>
        
      </div>

      <!-- start: search & user box -->
      <div class="header-right">

        <div class="localtime">{{localTime}}</div>
        <span class="separator"></span>

        <div id="userbox" class="userbox">
          <a href="#" type="button" class="" data-bs-toggle="dropdown" aria-expanded="false">
            <!-- <figure class="profile-picture">
              <img :src="pictureUrl" class="rounded-circle">
            </figure> -->
            <div class="profile-info">
              <span class="name">{{name}}</span>
              <span class="role">{{systemName}}</span>
            </div>

            <i class="fa custom-caret"></i>
          </a>

          <div class="dropdown-menu">
            <ul class="list-unstyled mb-2">
              <li class="divider" v-if="system"></li>
              <li v-for="item in system" :key="item.id">
                <a role="menuitem" tabindex="-1" @click="switchSystem(item.id)"><i class="fa fa-arrow-right"></i> 切換到 {{item.text}}</a>
              </li>
              <li class="divider"></li>
              <li>
                <a role="menuitem" tabindex="-1" @click="logout" class="logout-btn">
                  <i class="fas fa-power-off"></i> 登出
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- end: search & user box -->
    </header>
    <!-- end: header -->
    <div class="inner-wrapper">
      <!-- start: sidebar -->
      <aside id="sidebar-left" class="sidebar-left testB">
        <div class="sidebar-header">
          <!-- <div class="sidebar-title pl-4 text-muted ">功能列表</div> -->
          <div class="sidebar-toggle d-none d-md-block"  data-toggle-class="sidebar-left-collapsed" data-target="html" data-fire-event="sidebar-left-toggle" style="margin: 0px;" >
            <!-- <div class="sidebar-toggle d-none d-md-block"  style="margin: 0px;" > -->
          
            <i class="fa fa-th" aria-label="Toggle sidebar"></i>
          </div>
        </div>
        <menus ref="menu" @update="menuUpdate" />
      </aside>
      <!-- end: sidebar -->
      <section role="main" class="content-body">
        <header class="page-header">
          <h2>{{ $root.subTitle }}</h2>
          <!-- <h2>{{$root.title}}</h2> -->

          <!-- <div class="right-wrapper text-right mr-3">
            <breadcrumbs :list="breadcrumbs" />
          </div> -->
        </header>
        <router-view></router-view>
      </section>
    </div>

    <!-- BackToTop button -->
    <backToTop></backToTop>
  </section>
</template>

<script>
import signInHelper from "@/helpers/signInHelper";
import Menus from "shared/menus";
import breadcrumbs from "shared/breadcrumbs";
import backToTop from "shared/backToTopBtn";

import { theme, panel } from "@/assets/theme";
import { authentication, my } from "resource";
import lodash, { debounce } from 'lodash'
import store from "@/store";
import moment from "moment";
import CONST from '../../utils/const';

export default {
  data() {
    return {
      title: null,
      breadcrumbs: [],
      system: [],
      name: null,
      pictureUrl: "/images/!logged-user.jpg",
      systemName: null,
      localTimeInterval: null,
      localTime: "",
      logoutTimer: null,
    };
  },
  components: { Menus, breadcrumbs, backToTop },
  methods: {
    logout() {
      authentication.signOut();
      signInHelper.signOut();
    },
    menuUpdate(list) {
      this.breadcrumbs = list;
    },
    switchSystem(id) {
      signInHelper.switch(id);
    },
    getTime() {
      this.localTime = moment().format("YYYY/MM/DD HH:mm:ss");
    },

    getNewTimeout() {
      const _this = this
      return setTimeout(() =>{
        
        // Two sitation not allow to Timeout logout
        // 1. on "activityDetail" page
        // 2. on "liveStreaming" page and in full screen mode
        if(!window.location.href.includes("activityDetail")&&( !window.location.href.includes("liveStreaming") || document.fullscreenElement === null)){
          _this.logout();
        }
      },  30 * 60 * 1000)

    }
  },
  async mounted() {
    theme();
    panel();
    signInHelper.refreshToken();
    my.info().then(a => {
      store.dispatch('scenicArea/setRoleIds', a.body.roleIdList)
      store.dispatch('scenicArea/getMyRoleToScenicArea')
      this.name = a.body.name;
      this.systemName = a.body.systemName;
      if (a.body.pictureUrl) this.pictureUrl = a.body.pictureUrl;
    });
    my.system().then(a => {
      this.system = a.body;
    });
    await this.$recaptchaLoaded();
    this.$recaptchaInstance.hideBadge();

    this.localTimeInterval = setInterval(async () => {
      this.getTime();
    }, CONST.REFRESH_DAT_TIMER_SEC);

    this.logoutTimer = this.getNewTimeout()
    const _this = this

    document.addEventListener('click', () => {
      clearTimeout(_this.logoutTimer)
      _this.logoutTimer = null
      _this.logoutTimer = _this.getNewTimeout()
    })
  },
  updated() {
    panel();
  },
  destroyed() {
    if (this.localTimeInterval) {
      
      clearInterval(this.localTimeInterval);
    }

    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer)
    }
    this.localTimeInterval = null;
    this.logoutTimer = null
  },
};
</script>

<style>
a {
  cursor: pointer;
}

.logout-btn{
  display: block;
  width:100%;
}
/* #sidebar-left.sidebar-left-collapsed {
  width: 73px; 
} */

/* #sidebar-left:hover {
  width: 295px; 
} */

.sidebar-left {
  transition: width 0.2s ease-in-out;
}

.sidebar-left .sidebar-header .sidebar-toggle{
  width: 64px;
}
@media (any-hover: hover){
  /* 僅在可以 hover 的裝置執行 hover 效果 */
  .sidebar-left-collapsed .body>.inner-wrapper>.testB:hover  {
   width: 300px;
  }
}



.header .mobile-nav{
  background: transparent;
    cursor: pointer;
    height: 35px;
    width: 35px;
    line-height: 35px;
    font-size: 18px;
    color:rgba(0, 0, 0, 0.55);
    /* opacity: 0.8; */
}

.header .mobile-nav:hover{
  background-color: var(--bs-cyan);
}

.header .mobile-nav:hover i{
  color: var(--bs-white);
}

@media only screen and (max-width: 767px){
   body header .header-right{
    height:105px !important;
  }
}
   /* body header .header-right{
    height:105px !important;
  } */


@media only screen and (min-width: 768px){
  html.sidebar-left-collapsed .sidebar-left .nav-main a span {
    visibility: unset;
  }

  html.sidebar-left-collapsed .sidebar-left{
     width: 68px; 
  }

  html.sidebar-left-collapsed .sidebar-left .nav-main li.nav-expanded > ul.nav-children{
    display: block;
  }


}



/* li.nav-parent > a:after {
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    content: '\f107';
    color: #abb4be;
    position: absolute;
    right: 0;
    top: 0;
    padding: 14px 25px;
  } */

</style>
